import axios from 'axios';
import { loadingActions } from '@ciam/ui';
import { getEnvVariable } from '@ciam/env';
// 로딩 인터셉터를 위한 카운터
let requestCount = 0;
// 로딩을 건너뛰어야 하는 특수 헤더
const SKIP_LOADING_HEADER = 'X-Skip-Loading';
export class HttpClient {
    constructor() { }
    static getBaseUrl(type) {
        const urls = {
            default: getEnvVariable('VITE_DEFAULT_API_URL'),
            samsung: getEnvVariable('VITE_SAMSUNG_API_URL'),
            gigya: getEnvVariable('VITE_GIGYA_API_URL'),
        };
        return urls[type];
    }
    static createDefaultOptions(type) {
        const channel = new URLSearchParams(window.location.search).get('channel') ?? 'btp';
        const apiKey = getEnvVariable(`VITE_GIGYA_API_KEY_${channel.toUpperCase()}`);
        return {
            baseURL: this.getBaseUrl(type),
            headers: {
                'Content-Type': type !== 'gigya' ? 'application/json' : 'application/x-www-form-urlencoded',
            },
            ...(type === 'gigya' && {
                transformRequest: [
                    (data) => {
                        // gigya instance 일 경우 apiKey 파라미터 추가
                        const dataWithApiKey = {
                            ...data,
                            apiKey: apiKey,
                        };
                        return new URLSearchParams(dataWithApiKey);
                    },
                ],
            }),
        };
    }
    static getInstance(type) {
        if (!this.instances[type]) {
            this.instances[type] = axios.create(this.createDefaultOptions(type));
            this.setupInterceptors(this.instances[type]);
        }
        return this.instances[type];
    }
    static setupInterceptors(instance) {
        instance.interceptors.request.use((config) => {
            // 로딩을 건너뛰어야 하는지 확인
            const skipLoading = config.headers && config.headers[SKIP_LOADING_HEADER];
            if (!skipLoading) {
                requestCount++;
                if (requestCount === 1) {
                    // 첫 번째 요청에서만 로딩 표시
                    loadingActions.showLoading();
                }
            }
            // 특수 헤더 제거 (실제 요청에서는 사용되지 않도록)
            if (config.headers) {
                delete config.headers[SKIP_LOADING_HEADER];
            }
            return config;
        }, (error) => Promise.reject(error));
        instance.interceptors.response.use((response) => {
            // 원래 요청에서 로딩을 건너뛰었는지 확인
            const skipLoading = response.config.headers && response.config.headers[SKIP_LOADING_HEADER];
            if (!skipLoading) {
                requestCount--;
                if (requestCount === 0) {
                    // 모든 요청이 완료되었을 때만 로딩 숨기기
                    loadingActions.hideLoading();
                }
            }
            return response;
        }, (error) => {
            // 오류가 발생한 요청에서 로딩을 건너뛰었는지 확인
            const skipLoading = error.config && error.config.headers && error.config.headers[SKIP_LOADING_HEADER];
            if (!skipLoading) {
                requestCount--;
                if (requestCount === 0) {
                    loadingActions.hideLoading();
                }
            }
            return Promise.reject(error);
        });
    }
}
Object.defineProperty(HttpClient, "instances", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {}
});
// 로딩을 건너뛰는 요청을 만드는 도우미 함수
export const skipLoading = (config = {}) => {
    return {
        ...config,
        headers: {
            ...(config.headers || {}),
            [SKIP_LOADING_HEADER]: true,
        },
    };
};
export const gigyaInstance = HttpClient.getInstance('gigya');
export const samsungInstance = HttpClient.getInstance('samsung');
export const defaultInstance = HttpClient.getInstance('default');
export default HttpClient;
//# sourceMappingURL=instance.js.map